module.exports = __webpack_public_path__ + "static/img/6.2eb5f44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/eng/6.png
// module id = 8mR9
// module chunks = 0